<template>
  <div 
    class="ios-person-row" 
    :class="{ 'ios-person-row--last': last }"
    @click="handleClick"
  >
    <div class="person-avatar" :style="!avatar && avatarColor ? { background: avatarColor } : {}" @click.stop="emit('avatar-click')">
      <img v-if="avatar" :src="avatar" :alt="name" />
      <span v-else-if="initials" class="avatar-initials">{{ initials }}</span>
      <v-icon v-else size="24">mdi-account</v-icon>
    </div>
    
    <div class="person-info">
      <div class="person-name">{{ name }}</div>
      <div v-if="role" class="person-role">{{ role }}</div>
      <slot name="subtitle" />
    </div>
    
    <div class="person-actions">
      <slot name="actions">
        <v-icon v-if="showChevron" size="18" class="person-chevron">mdi-chevron-right</v-icon>
      </slot>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  name: {
    type: String,
    required: true
  },
  role: {
    type: String,
    default: ''
  },
  avatar: {
    type: String,
    default: ''
  },
  avatarColor: {
    type: String,
    default: ''
  },
  initials: {
    type: String,
    default: ''
  },
  showChevron: {
    type: Boolean,
    default: true
  },
  last: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['click', 'avatar-click']);

const handleClick = () => {
  emit('click');
};
</script>

<style lang="scss" scoped>
.ios-person-row {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  min-height: 56px;
  position: relative;
  cursor: pointer;
  transition: background 0.15s ease;
  
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 16px;
    right: 16px;
    height: 1px;
    background: linear-gradient(90deg,
      transparent 0%,
      rgba(var(--v-theme-sheetText), 0.1) 20%,
      rgba(var(--v-theme-sheetText), 0.1) 80%,
      transparent 100%);
  }
  
  &:active {
    background: rgba(var(--v-theme-sheetText), 0.12);
  }
  
  &--last::after {
    display: none;
  }
}

.person-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(var(--v-theme-sheetText), 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  overflow: hidden;
  flex-shrink: 0;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .avatar-initials {
    font-size: 13px;
    font-weight: 700;
    color: white;
  }
}

.person-info {
  flex: 1;
  min-width: 0;
}

.person-name {
  font-size: 1rem;
  color: rgb(var(--v-theme-sheetText));
}

.person-role {
  font-size: 0.8rem;
  color: rgba(var(--v-theme-sheetText), 0.5);
  margin-top: 2px;
}

.person-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.person-chevron {
  color: rgba(var(--v-theme-sheetText), 0.3);
}
</style>
